// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InfoTooltip__infoTooltip___27pFa{display:flex;align-items:center;background-color:#e1f0fe;padding:8px;border-radius:8px;font-size:12px;color:#333;line-height:1.4}.InfoTooltip__infoTooltipText___2yWyu{text-align:center}.InfoTooltip__infoTooltipError___3kCie{background-color:rgba(255,59,10,0.12)}.InfoTooltip__infoTooltipIcon___3MfGa{margin-right:8px;min-width:24px;min-height:24px;width:24px;height:24px}.InfoTooltip__infoTooltip___27pFa em{padding-top:6px;display:inline-block}.InfoTooltip__infoTooltip___27pFa a{color:#0c4da2}\n", ""]);
// Exports
exports.locals = {
	"infoTooltip": "InfoTooltip__infoTooltip___27pFa",
	"infoTooltipText": "InfoTooltip__infoTooltipText___2yWyu",
	"infoTooltipError": "InfoTooltip__infoTooltipError___3kCie",
	"infoTooltipIcon": "InfoTooltip__infoTooltipIcon___3MfGa"
};
module.exports = exports;
